import ZContactCard from './ZContactCard.vue'

export default ZContactCard
